import RecommendedShelf from './RecommendedShelf';

export default RecommendedShelf;
